module.exports = __webpack_public_path__ + "media/assets/images/flags/tw-bb69a1028280599fffc7a8dd4aa06645.svg";